import Web3 from 'web3'

export const makeContract = <T = any>(library: any, abi: any, address: string): T => {
  const web3 = new Web3(library?.provider)
  return new web3.eth.Contract(abi, address) as unknown as T
}
